import {CreateLibrarySection, UpdateLibrarySection, LibrarySectionId, OwnerId} from "platformed-client/types";
import {invalidateQueries, q} from "../../state";
import {platformedClient} from "..";

export async function list() {
  return await platformedClient.internalRequest("get", `/region/{region}/api/vendor_toolkit/library_sections`, {});
}

export async function get(librarySectionId: LibrarySectionId) {
  return await platformedClient.internalRequest("get", `/region/{region}/api/vendor_toolkit/library_sections/{id}`, {
    path: {id: librarySectionId},
  });
}

export async function create(librarySection: CreateLibrarySection) {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/vendor_toolkit/library_sections`, {
    body: librarySection,
  });
  await invalidateQueries([q.vendorToolkit.librarySections.filter()]);
  return res;
}

export async function update(librarySectionId: LibrarySectionId, librarySection: UpdateLibrarySection) {
  const res = await platformedClient.internalRequest(
    "patch",
    `/region/{region}/api/vendor_toolkit/library_sections/{id}`,
    {path: {id: librarySectionId}, body: librarySection},
  );
  await invalidateQueries([q.vendorToolkit.librarySections.filter()]);
  return res;
}

export async function assign(librarySectionId: LibrarySectionId, owner: OwnerId | null) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/library_sections/{id}/assign`,
    {path: {id: librarySectionId}, body: owner},
  );
  await invalidateQueries([q.vendorToolkit.librarySections.filter()]);
  return res;
}

export async function deleteLibrarySection(librarySectionId: LibrarySectionId) {
  const res = await platformedClient.internalRequest(
    "delete",
    `/region/{region}/api/vendor_toolkit/library_sections/{id}`,
    {path: {id: librarySectionId}},
  );
  await invalidateQueries([q.vendorToolkit.librarySections.filter()]);
  return res;
}
